
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import NewSwiper from '@xt/www/components/newSwiper/index.vue'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    LazyImg,
    NewSwiper
  }
})
export default class CoursesContent extends Vue {
  current: string = 'zzsx'
  tabList: string[] = ['zzsx', 'zczm'] as const

  picSource: {
    zzsx: string[]
    zczm: string[]
  } = {
    zzsx: [
      'https://file.xuantong.cn/images/origin/aac54c0e9c56b68ac925418d6fe85b43.png',
      'https://file.xuantong.cn/images/origin/58ab4954dfc6e568e9422b7d6e540845.png',
      'https://file.xuantong.cn/images/origin/aac54c0e9c56b68ac925418d6fe85b43.png',
      'https://file.xuantong.cn/images/origin/58ab4954dfc6e568e9422b7d6e540845.png',
      'https://file.xuantong.cn/images/origin/aac54c0e9c56b68ac925418d6fe85b43.png',
      'https://file.xuantong.cn/images/origin/58ab4954dfc6e568e9422b7d6e540845.png'
    ],
    zczm: [
      'https://file.xuantong.cn/images/origin/5cdb7c73dcb63e47b52a9f7828dbd77b.png',
      'https://file.xuantong.cn/images/origin/5cdb7c73dcb63e47b52a9f7828dbd77b.png',
      'https://file.xuantong.cn/images/origin/5cdb7c73dcb63e47b52a9f7828dbd77b.png',
      'https://file.xuantong.cn/images/origin/5cdb7c73dcb63e47b52a9f7828dbd77b.png',
      'https://file.xuantong.cn/images/origin/5cdb7c73dcb63e47b52a9f7828dbd77b.png'
    ]
  }

  get picList() {
    return this.picSource[this.current] ?? []
  }

  onSelect(t: string) {
    if (this.current === t) return
    this.current = t
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
